import Axios from 'axios'

const supply = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.SUPPLY_URL
    return AxiosInstance
  },
  getSupplyRequest (id) {
    return this.axios().get('/supply/request/' + id)
  },
  updateSupplyRequest (id, request) {
    return this.axios().put('/supply/request/' + id, request)
  },
  deleteSupplyRequest (id) {
    return this.axios().delete('/supply/request/' + id)
  },
  getSupplyRequests ({ startDate, endDate, situations, status }) {
    return this.axios().get('/supply/request/filter', {
      params: {
        endDate: endDate,
        situations: situations,
        startDate: startDate,
        status: status
      }
    })
  },
  getSupplyRequestStatus () {
    return this.axios().get('/supply/request/status')
  },
  getSupplyRequestSituation () {
    return this.axios().get('/supply/request/situation')
  },
  createSupplyRequest (item) {
    return this.axios().post('/supply/request', item)
  },
  getSupplyByText (text) {
    return this.axios().get('/supply/supplies', {
      params: {
        searchText: text
      }
    })
  },
  getReasons () {
    return this.axios().get('/supply/request/reasons')
  }
}

export default supply
